/**
 * plugins/index.js
 *
 * Automatically included in `./src/main.js`
 */

// Plugins
import storage from '@/storage';
import { createAxios } from '@/plugins/axios';
import vuetify from '@/plugins/vuetify';

const resolveToken = () => {
  const url = new URL(window.location.href);
  const { pathname } = url;
  const widgetId = pathname.split('/').pop();
  return widgetId;
};

export function registerPlugins (app) {
  app.use(vuetify);
  const storageAxios = createAxios(import.meta.env.VITE_ROOT_API, resolveToken);
  app.use(storage, { axios: storageAxios });
}
